module.exports = __webpack_public_path__ + "img/kvalitetselement_hydromorfologiske.28435582.jpg";